import React, { useState } from 'react'
import classNames from 'classnames'

export default React.memo((props) => {
  const { title, imgActive, imgInactive, active, className, imgStyle } = props
  const [onHover, setOnHover] = useState(false)

  const onMouseEnter = () => {
    setOnHover(true)
  }
  const onMouseLeave = () => {
    setOnHover(false)
  }

  let iconObj = null; let iconObj_inActive = null
  if (imgActive && imgInactive) {
    iconObj = <img alt="" className="activeIcon" src = {asset(imgActive)} style={imgStyle} />
    iconObj_inActive = <img alt="" className="inactiveIcon" src = {asset(imgInactive)} style={imgStyle} />
  }
  const classes = classNames({
    'tab-title-content': true,
    active,
    'hover': onHover,
  }, className)

  return (
    <div
      className={classes}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {iconObj}
      {iconObj_inActive}
      <div className='title'>
        {title}
      </div>
    </div>
  )
})
